export interface RequisitionDetail {
    id?: string;
    requisitionId?: string;
    itemId: string;
    itemName?: string;
    requiredQty: number;
    approvedQty?: number;
    approvedDate?: string;
    issuedDate?: string;
    /** F6b: the issuing store (set at approval). */
    storeId?: string;
}

export type RequisitionStatus = 'NEW' | 'APPROVED' | 'ISSUED' | 'REJECTED';

export const REQUISITION_STATUS_LABELS: Record<RequisitionStatus, string> = {
    NEW: 'New',
    APPROVED: 'Approved',
    ISSUED: 'Issued',
    REJECTED: 'Rejected',
};

export interface Requisition {
    selfApproved?: boolean;
    selfApprovalRule?: string | null;
    id?: string;
    refNo?: string;
    status?: RequisitionStatus;
    date?: string;
    requisitionById?: string;
    requisitionByName?: string;
    remarks?: string | null;
    rejectionReason?: string | null;
    details?: RequisitionDetail[];
    /** Set when stock moved but the consumption could not be (fully) posted to the ledger. */
    journalWarning?: string | null;
    /** W3-I: buyer order the issue is costed to. */
    buyerOrderId?: string | null;
}

export interface RequisitionCreateDTO {
    institutionId: string;
    remarks?: string;
    buyerOrderId?: string;
    details: RequisitionDetail[];
}

export interface RequisitionResponse {
    content: Requisition[];
    pageable: {
        pageNumber: number;
        pageSize: number;
        sort: {
            sorted: boolean;
            empty: boolean;
            unsorted: boolean;
        };
        offset: number;
        paged: boolean;
        unpaged: boolean;
    };
    last: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    number: number;
    sort: {
        sorted: boolean;
        empty: boolean;
        unsorted: boolean;
    };
    numberOfElements: number;
    first: boolean;
    empty: boolean;
}
